<template>
  <el-container style="height: 100%;">
    <el-header height="auto">
      <el-row align="middle" justify="flex-start" style="height: 100%; flex-wrap: wrap; margin: 10px 10px 0 0;" type="flex">
        <el-button v-if="user.roleId===1 && selectedEmployees.length > 0" @click="editMultipleEmployeesDialog.visible = true">修改部门</el-button>
      </el-row>
      <el-row align="middle" justify="flex-end" style="flex-wrap: wrap; margin: 20px 10px 0 0;" type="flex">
        <span style="color: darkgrey; font-size: 13px;">公司总人数：{{ employees.length }}人</span>
      </el-row>
      <el-dialog
          :visible.sync="editEmployeeDialog.visible"
          title="编辑员工资料"
          width="30%">
        <el-row justify="space-between" type="flex">
                    <span style="height: 100%;">
                        <span style="height: 100%; line-height: 40px;">姓名</span>
                    </span>
          <span style="margin: 0 0 0 10px;">
                        <el-input v-model="editEmployeeDialog.employee.name" readonly></el-input>
                    </span>
        </el-row>
        <el-row justify="space-between" style="margin: 10px 0 0 0;" type="flex">
                    <span style="height: 100%;">
                        <span style="height: 100%; line-height: 40px;">部门</span>
                    </span>
          <span style="margin: 0 0 0 10px;">
                        <el-select v-model="editEmployeeDialog.departmentId" placeholder="待加入的部门">
                            <el-option
                                v-for="item in departments"
                                :key="item.depId"
                                :label="item.name"
                                :value="item.depId">
                            </el-option>
                        </el-select>
                    </span>
        </el-row>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="editEmployeeDialog.visible = false">取 消</el-button>
                    <el-button type="primary" @click="editEmployeeDialogConfirmed">确 定</el-button>
                </span>
      </el-dialog>

      <el-dialog
          :visible.sync="editMultipleEmployeesDialog.visible"
          title="编辑员工资料"
          width="30%">
        <el-row justify="space-between" style="margin: 10px 0 0 0;" type="flex">
                    <span style="height: 100%;">
                        <span style="height: 100%; line-height: 40px;">部门</span>
                    </span>
          <span style="margin: 0 0 0 10px;">
                        <el-select v-model="editMultipleEmployeesDialog.departmentId" placeholder="待加入的部门">
                            <el-option
                                v-for="item in departments"
                                :key="item.depId"
                                :label="item.name"
                                :value="item.depId">
                            </el-option>
                        </el-select>
                    </span>
        </el-row>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="editMultipleEmployeesDialog.visible = false">取 消</el-button>
                    <el-button type="primary" @click="editMultipleEmployeesDialogConfirmed">确 定</el-button>
                </span>
      </el-dialog>
    </el-header>
    <el-main>
      <el-table
          :data="employees"
          height="500px"
          style="width: 100%"
          width="100%"
          @selection-change="selectionChanged">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="姓名"
            prop="name"
            sortable
            width="80">
        </el-table-column>
        <el-table-column
            label="权限"
            width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.roleId === 1">企业管理员</span>
          </template>
        </el-table-column>
        <el-table-column
            label="部门"
            prop="department.name"
            sortable
            width="120">
        </el-table-column>
        <el-table-column
            label="本月记录问题数量"
            prop="issueCreated"
            sortable
            width="180">
        </el-table-column>
        <el-table-column
            label="本月待解决问题数量"
            prop="issueUnsolved"
            sortable
            width="180"/>
        <el-table-column
            label="本月待验收问题数量"
            prop="issueUnverify"
            sortable
            width="180"/>
        <el-table-column
            label="本月已验收问题数量"
            prop="issueSolve"
            sortable
            width="180"/>
        <el-table-column
            label="本月解决问题数量"
            prop="issueSolved"
            sortable
            width="180"/>
        <el-table-column
            label="本月待验收问题数量"
            prop="issueUnverified"
            sortable
            width="180"/>
        <el-table-column
            label="本月未通过问题数量"
            prop="issueRejected"
            sortable
            width="180"/>
        <el-table-column
            label="本月已验收问题数量"
            prop="issueVerified"
            sortable
            width="180"/>
        <el-table-column
            label="上次登录的时间"
            prop="lastLoginRelativeTime"
            sortable
            width="180"/>
        <el-table-column
            v-if="user.roleId===100"
            label="操作"
            width="100">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="editEmployeeButtonClicked(scope.row)">编辑</el-button>
            <el-button size="small" type="text" @click="removeEmployee(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import axios from "axios";
import app from "@/App";
import qs from "qs";

export default {
  name: "Employees",
  data() {
    return {
      user: {},
      dialogVisible: false,
      employees: [],
      departments: [],
      addEmployeeDialog: {
        departmentId: null,
        employees: null
      },

      editEmployeeDialog: {
        visible: false,
        employee: {},
        departmentId: null,
      },

      editMultipleEmployeesDialog: {
        visible: false,
        departmentId: null,
      },

      selectedEmployees: [],

      notifyPromise: Promise.resolve()
    }
  },
  created() {
    app.methods.getUser().then(res => {
      this.user = res.data.data;
      this.getEmployees();
      this.getDepartments();
    })
  },
  methods: {
    async getDepartments() {
      this.departments = (await app.methods.getAllDepartmentsOfCompany(this.user.company.companyId)).data.data;
    },

    getEmployees() {
      app.methods.getEmployees(
          this.user.company.companyId
      ).then(res => {
        this.employees = res.data.data.list;
      });
    },
    addEmployeeDialogConfirmed() {
      this.addEmployeeDialog.employees.split('\n').forEach(phoneNumber => {
        this.addEmployee(phoneNumber.trim(), this.addEmployeeDialog.departmentId)
      })
    },
    addEmployee(phoneNumber, departmentId) {
      if (phoneNumber.length === 0)
        return;

      if (!phoneNumber.match(/^\d{11}$/)) {
        this.notifyPromise = this.notifyPromise.then(() =>
            this.$notify.error({
              title: '提示',
              message: '手机号：' + phoneNumber + ' 不合法',
              duration: 0
            }));

        return;
      }

      app.methods.addEmployee(phoneNumber, this.user.company.cId, departmentId).then((res) => {
        if (res.data.status !== 1) {
          this.$notify.error({
            title: '提示',
            message: '添加用户：' + phoneNumber + ' 失败，' + res.data.info,
            duration: 0
          });
        }
        this.getEmployees();
      })
    },
    editEmployeeDialogConfirmed() {
      app.methods.setEmployeeDepartment(this.editEmployeeDialog.employee.userId, this.editEmployeeDialog.departmentId)
          .then(res => {
            if (res.data.status === 1) {
              this.$notify.success({title: res.data.info, message: null});
              this.getEmployees();
              this.editEmployeeDialog.visible = false;
            } else {
              this.$notify.error({title: res.data.info, message: null})
            }
          });
    },
    editEmployeeButtonClicked(employee) {
      this.editEmployeeDialog.employee = employee;
      this.editEmployeeDialog.visible = true;
      this.editEmployeeDialog.departmentId = employee.depId;
    },
    editMultipleEmployeesDialogConfirmed() {
      this.selectedEmployees.forEach(employee => {
        app.methods.setEmployeeDepartment(employee.userId, this.editMultipleEmployeesDialog.departmentId).then(res => {
          if (res.data.status !== 1)
            this.$notify.error({title: '修改 ' + employee.name + ' 的部门失败', message: res.data.info, duration: 0})
        })
      });

      this.editMultipleEmployeesDialog.visible = false;
      this.getEmployees();
    },
    selectionChanged(itemSelected) {
      this.selectedEmployees = itemSelected;
    },
    removeEmployee(staff) {
      axios.post(app.url + '/company/deleteMember', qs.stringify({
        userId: staff.userId
      })).then(res => {
        if (res.data.status === 1) {
          alert("删除成功");
          this.getEmployees();
        } else {
          alert(res.data.info);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
